// extracted by mini-css-extract-plugin
export default {"past-students-container":"PastStudents_past-students-container__C0+pe","project-list":"PastStudents_project-list__ZN39d"};